"use client";

import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid'
import ReactPaginate from 'react-paginate';

const Pagination = props => {
  const {
    onPageChange,
    currentPage,
    totalCount,
    pageSize,
  } = props;
  return (
    <ReactPaginate
      breakLabel={<span className="mx-3">...</span>}
      pageCount={Math.ceil(totalCount / pageSize)}
      pageRangeDisplayed={5}
      marginPagesDisplayed={2}
      previousLabel={<ChevronLeftIcon className="text-gray-400 h-5 w-5" aria-hidden="true"/>}
      nextLabel={<ChevronRightIcon className="text-gray-400 h-5 w-5" aria-hidden="true"/>}
      initialPage={currentPage - 1}
      forcePage={currentPage - 1}
      onPageChange={onPageChange}
      containerClassName="flex items-center justify-center mt-8 mb-4"
      activeLinkClassName="bg-blue-600 text-white focus-visible:outline-blue-600 focus-visible:outline-2 focus-visible:outline-offset-2 ring-0 ring-inset ring-blue-300 focus-visible:outline-blue-600 hover:bg-blue-600"
      pageLinkClassName="relative pagination-item items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 inline-flex"
      previousLinkClassName="inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
      nextLinkClassName="inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
    />
  )
}

export default Pagination;
